import { useCallback, useState } from 'react'

import { ReportOrderType } from '@driftt/api-types'

import { ISortConfig } from 'api/report/query/types'

type UseSortConfigReturnType = [ISortConfig, (nextMetric: string) => void]

const useSortConfig = (
  metric: string,
  order: ReportOrderType = ReportOrderType.DESC
): UseSortConfigReturnType => {
  const [sortConfig, setSortConfig] = useState<{
    metric: string
    order: ReportOrderType
  }>({
    metric,
    order,
  })

  const sortHandler = useCallback(
    (nextMetric: string) => {
      if (nextMetric === null) {
        // Workaround for Tide table sending clicks on non-sortable columns.
        return
      }
      const nextOrder: ReportOrderType =
        nextMetric === sortConfig.metric
          ? sortConfig.order === ReportOrderType.ASC
            ? ReportOrderType.DESC
            : ReportOrderType.ASC
          : ReportOrderType.DESC
      setSortConfig({
        metric: nextMetric,
        order: nextOrder,
      })
    },
    [sortConfig.metric, sortConfig.order]
  )

  return [sortConfig, sortHandler]
}

export default useSortConfig
